import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/antibodies_analytics.py
export const ANTIBODIES_ANALYTICS_ACTIONS = {
  // Antibody format events
  CLICKED_CREATE_NEW_FORMAT: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'clicked_create_new_format',
    actionCategory: ACTION_CATEGORY.READ,
  },
  TYPED_CUSTOM_FORMAT_DISPLAY_NAME: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'typed_custom_format_display_name',
    actionCategory: ACTION_CATEGORY.READ,
  },
  TYPED_CUSTOM_FORMAT_VERITAS_NAME: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'typed_custom_format_veritas_name',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PREVIEWED_VERITAS_FORMAT: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'previewed_veritas_format',
    actionCategory: ACTION_CATEGORY.READ,
  },
  VERITAS_FORMAT_PREVIEW_RETURNED_ERRORS: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'veritas_format_preview_returned_errors',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CREATED_ANTIBODY_FORMAT: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'created_antibody_format',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SELECTED_ANTIBODY_FORMAT_ON_SCHEMA: {
    module: ANALYTICS_MODULE.ANTIBODIES,
    action: 'selected_antibody_format_on_schema',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
